// LP personalization token: ?t= carries { policyId, firstName, destination, departureDate, travelerCount }.
// Real signature validation lands via a backend-provided secret/endpoint (not available yet).
// Until then REACT_APP_TOKEN_MOCK=true accepts a base64 JSON payload so the personalized path is testable.
// parseToken()'s return shape must not change when the real validator replaces the mock branch below.

const EMPTY = {
  valid: false,
  policyId: null,
  firstName: null,
  destination: null,
  departureDate: null,
  travelerCount: 1,
};

const decodeMockToken = (raw) => {
  try {
    const json = JSON.parse(atob(raw));
    return {
      valid: true,
      policyId: json.policyId ?? null,
      firstName: json.firstName ?? null,
      destination: json.destination ?? null,
      departureDate: json.departureDate ?? null,
      travelerCount: Number(json.travelerCount) > 0 ? Number(json.travelerCount) : 1,
    };
  } catch {
    return null;
  }
};

// {{TOKEN_SIGNING_SECRET}} — not available yet. Swap this branch for real verification
// (e.g. HMAC check or a call to a token-resolution endpoint) without changing parseToken's return shape.
const decodeRealToken = () => null;

export const parseToken = (searchString) => {
  const params = new URLSearchParams(searchString);
  const raw = params.get('t');
  if (!raw) return { ...EMPTY };

  const decoded = process.env.REACT_APP_TOKEN_MOCK === 'true'
    ? decodeMockToken(raw)
    : decodeRealToken(raw);

  return decoded || { ...EMPTY };
};

// Convenience for local/dev testing: btoa(JSON.stringify({...})) to hand-build a `?t=` value.
export const encodeMockToken = (payload) => btoa(JSON.stringify(payload));
